import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { RectifyDefectHeader, SubmitResolvedDefects } from 'src/app/models/rectify-defects.model';

@Injectable({
  providedIn: 'root',
})
export class RectifyDefectsService {

  private submitResolvedDefects: SubmitResolvedDefects = new SubmitResolvedDefects();

  constructor(private readonly apiService: ApiService) { }

  setResolvedDefectDetail(data: SubmitResolvedDefects) {
    this.submitResolvedDefects = data;
  }

  getResolvedDefectDetail() {
    if (!this.submitResolvedDefects) {
      this.submitResolvedDefects = new SubmitResolvedDefects();
    }
    return this.submitResolvedDefects;
  }

  resetResolvedDefectDetail() {
    this.submitResolvedDefects = new SubmitResolvedDefects();
    return this.submitResolvedDefects;
  }

  // API CALLS
  getUnresolvedDefectsByIcnNo(icnNo: number) {
    return this.apiService.get<RectifyDefectHeader[]>(
      `GetUnresolvedDefectByIcnNo/${icnNo}`
    );
  }

  updateInspectionResolvedDefect(payload: SubmitResolvedDefects) {
    return this.apiService.post<SubmitResolvedDefects, number>(`updateInpsectionReportDefect`, payload);
  }
}
